import Footer from "@/components/@extended/Footer";
import MainBox from "@/components/Box/MainBox";
import BasicSelect from "@/components/Select/BasicSelect";
import { IBasicSelectItem } from "@/interfaces/Props/Select/IBasicSelectProps";
import { handleNextActiveStep, setProjcet } from "@/redux/features/Service/serviceSlice";
import { useAppDispatch } from "@/redux/hooks";
import useMessage from "@/useHooks/useMessage";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";

const Layout = () => {

  const dispatch = useAppDispatch();

  const { formatMessage } = useMessage();

  const [selectProject, setSelectProject] = useState<string>("SQCTYatBMdZtDIBanpwS");

  const [disabledNext, setDisabledNext] = useState<boolean>(false);

  const projects: Array<IBasicSelectItem> = [
    { label: "Sprinkler", value: "SQCTYatBMdZtDIBanpwS" },
  ];

  const handleSelectProjectCallBack = (value?: string) => {
    if (value) {
      setSelectProject(value);
    }
  };

  const handleOnNextClick = () => {
    if (selectProject !== "default") {
      dispatch(handleNextActiveStep());
    }
  };

  useEffect(() => {
    dispatch(setProjcet(selectProject));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    dispatch(setProjcet(selectProject));
    if (selectProject === "default") {
      setDisabledNext(true);
    } else {
      setDisabledNext(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectProject]);


  return (
    <MainBox height={"100%"}>
      <Box sx={{ minHeight: "calc(100% - 50px)" }}>
        <BasicSelect
          label={formatMessage({
            id: "page_one_select_electronic_project",
          })}
          defaultValue={selectProject}
          items={projects}
          callback={handleSelectProjectCallBack}
        />
      </Box>
      <Footer
        hideBack
        disabledNext={disabledNext}
        onNextClick={handleOnNextClick}
      />
    </MainBox>
  );
};

export default Layout;
